import {Client, IFrame, IMessage} from "@stomp/stompjs";
import {WebSocketTopicName} from "../model/WebSocketTopicName";

export class WebSocketService {

    static instance = ['$wsClient', WebSocketService];

    constructor(private $wsClient: Client) {
    }

    public startSession(topicName: WebSocketTopicName, messageCallback: (message: IMessage) => void) {
        if (this.$wsClient.connected) {
            console.log("ws client is active!");
            this.$wsClient.subscribe(topicName, messageCallback);
        } else {
            console.log("ws client will subscribe once active...!");
            this.$wsClient.onConnect = (frame: IFrame) => {
                this.$wsClient.subscribe(topicName, messageCallback);
            };
        }
    }

    public stopSession(topicName: WebSocketTopicName) {
        this.$wsClient.unsubscribe(topicName);
    }

}